import { useMediaQuery } from '@surveycake/rhooks';
import throttle from 'lodash/throttle';
import React, { FC, useCallback, useRef } from 'react';
import { useStyles } from './styles';

const Container: FC = ({ children }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const classes = useStyles();
  const handleMediaQuery = useCallback<Parameters<typeof useMediaQuery>[0]>(
    throttle(
      ({ height }) => {
        if (contentRef.current) {
          contentRef.current.style.minHeight = `${height - 200}px`;
        }
      },
      1000,
      { trailing: false }
    ),
    []
  );

  useMediaQuery(handleMediaQuery);

  return (
    <div className={classes.container} aria-label="container">
      <div ref={contentRef} className={classes.content}>
        {children}
      </div>
    </div>
  );
};

export default Container;
